<template>
	<StandardModal
		open
		:title="group.title"
		:confirmText="$t('common_button_delete')"
		:confirmProps="{ danger: true, loading: isProcessing }"
		@confirm="deleteGroup"
		@cancel="close"
		small
		ref="modal"
	>
		<div class="modal-wrapper">
			<TrashCanIcon halo />
			{{ $t('admin_groups_delete_warning_label') }}
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { TrashCanIcon } from '@/icons'
import { del } from '../common'
import { storage } from '@/helpers/utils'

export default {
	name: 'DeleteGroupModal',
	components: { StandardModal, TrashCanIcon },
	props: {
		group: Object,
	},
	data() {
		return {
			isProcessing: false,
		}
	},

	emits: ['delete', 'close'],

	methods: {
		async deleteGroup() {
			this.isProcessing = true
			try {
				await del(`/organization/groups/${this.group.id}`)
				storage.set('org_mgmt_changed_groups', true)
				this.$alert.success(this.$t('admin_groups_group_deleted_confirmation'))
				this.$emit('delete')
				this.close()
			} catch (e) {
				this.isProcessing = false
				this.$refs.modal.$alert.error(this.$t('common_api_error_save'))
			}
		},
		close() {
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.modal-wrapper {
	@include flex-column-center;
	max-width: 300px;
	margin: 24px auto;
	text-align: center;
	.pronto-icon {
		color: var(--red-200);
		font-size: 50px;
		margin-bottom: 24px;
	}
}
</style>
